import React, {useEffect, useRef} from 'react';
import {Link} from 'react-router-dom';
import styles from './MobileMenu.module.css';
import {CREATE_PAGE_ROUTE, HOW_TO_ROUTE, CONTACT_ROUTE, LOGIN_ROUTE} from '../routes';

const LINKS = [
    {to: CREATE_PAGE_ROUTE, label: 'Create page'},
    {to: HOW_TO_ROUTE, label: 'How to'},
    {to: CONTACT_ROUTE, label: 'Contact'},
];

const MobileMenu = ({open, onClose, currentPath}) => {
    const lastPath = useRef(currentPath);

    useEffect(() => {
        if (!open) return undefined;

        const onKeyDown = (e) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', onKeyDown);

        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        return () => {
            document.removeEventListener('keydown', onKeyDown);
            document.body.style.overflow = previousOverflow;
        };
    }, [open, onClose]);

    useEffect(() => {
        if (open && lastPath.current !== currentPath) {
            onClose();
        }
        lastPath.current = currentPath;
    }, [currentPath, open, onClose]);

    if (!open) return null;

    return (
        <div id="mobile-menu" className={styles.sheet}>
            <nav aria-label="Mobile" className={styles.list}>
                {LINKS.map(({to, label}) => (
                    <Link key={to} to={to} className={styles.row} onClick={onClose}>
                        {label}
                    </Link>
                ))}
                <div className={styles.divider}/>
                <Link to={LOGIN_ROUTE} className={styles.row} onClick={onClose}>
                    Log in
                </Link>
            </nav>
        </div>
    );
};

export default MobileMenu;
